import {getFormValues} from "redux-form";
import {FORM_NAME} from "../../modules/form";
import {getState} from "helpers";

export const getApplicationFormValues = () => getFormValues(FORM_NAME)(getState());
